export default __webpack_public_path__ + "static/media/Group1.e94f8e5d.png";